import React, { useEffect, useMemo, useRef, useState } from "react"
import { DatePicker, Input, Select, Tag, Tooltip } from "antd"
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs"
import { useLocation, useSearchParams } from "react-router-dom";

// Components
import SvgIcon from "src/components/SvgIcon"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import TableCustom from "src/components/Table/CustomTable"
import ToolBarCustomLayer from "src/components/ToolBarCustom/ToolBarCustomLayer"
import ContactCustomer, { statusCall } from "./components/ContactCustomer"
import CustomModal from "src/components/Modal/CustomModal"
import ModalAssigner from "./modal/ModalAssigner"
import ModalFastAssigner from "./modal/ModalFastAssigner"
import ImportModal from "./modal/ExportModal"
import Notice from "src/components/Notice";

// Utils
import STORAGE, { getStorage } from "src/lib/storage"
import { fetchContactList, setListCar } from "src/redux/crm";
import { setDepartmentId } from "src/redux/hr";

// Styled
import { WrapperStyle, SelectStyle } from "./common/styled"
import { PaginationStyle } from "../../HumanResource/styled"
import { InputSearchStyle } from "../customer/common/styled"
import {
  MainTableData,
  MainTableHeader,
  SubTableData,
  SubTableHeader
} from "src/components/Table/CustomTable/styled"
import CB1 from "../../../../components/Modal/CB1";
import HRService from "../../../../services/HumanResource";
import notice from "../../../../components/Notice";
import { CALL_STATE, PAGE_SIZE } from "src/constants/constants";
import CRMService from "../../../../services/CRMService";
import { ModalConfirmDelete } from "./modal/ModalConfirmDelete";
import { DATE_FORMAT_SLASH, momentDateToString } from "src/lib/dateFormatters";
import { formatCurrency } from "src/lib/utils";
import { INTENDED_USE } from "./index";
import Button from "src/components/MyButton/Button";

const headerCell = () => ({
  style: { minWidth: 80 },
})

function Index(props) {
  const { status, type } = props

  const { callState } = useSelector((state) => state.calling);

  const initialFilter =
    type === "callback_Date"
      ? { callback_Date: dayjs().format('YYYY-MM-DD') }
      : type === "renewal" || type === "return"
        ? { assigned: false }
        : {};

  const dispatch = useDispatch()
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ''; // Sau sẽ lưu/sử dụng từ redux sau khi tách riêng api
  const role = localStorage.getItem(STORAGE.ROLES) || '';

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [filter, setFilter] = useState(initialFilter)
  const [tempFilter, setTempFilter] = useState(initialFilter);

  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalAssignerVisible, setIsModalAssignerVisible] = useState(false);
  const [isModalFastAssignerVisible, setIsModalFastAssignerVisible] = useState(false);
  const [isModalDeletes, setIsModalDeletes] = useState(false);
  const [isModalAssignerImport, setIsModalAssignerImport] = useState(false);
  const [isModalContactCustomer, setIsModalContactCustomer] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const { listDepartment, listProvince, listPersonnelAssigner, departmentId } = useSelector((state) => state.hr)
  const { dataContact, statistical, total, loading } = useSelector((state) => state.crm);
  const [listCarState, setListCarState] = useState([]) // Đổi tên state để tránh nhầm lẫn với listCar từ Redux (nếu có)
  // const [dataContact, setDataContact] = useState([]);
  // const [statistical, setStatistical] = useState({});
  // const [total, setTotal] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get('id');
  const personnelOptions = useMemo(() => {
    const depId = filter?.department_id ?? null;
    const list = Array.isArray(listPersonnelAssigner) ? listPersonnelAssigner : [];
    const filtered = depId
      ? list.filter(p => Number(p.department_id) === Number(depId))
      : list;
    return filtered.map(p => ({ value: p.ID, label: p.name }));
  }, [listPersonnelAssigner, filter?.department_id]);

  const updateTempFilter = (key, value) => {
    setTempFilter(prev => {
      const next = { ...prev };

      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        next[key] = null;
      } else {
        next[key] = value;
      }

      return next;
    });
  };
  const location = useLocation();
  const isCalling = location.state?.isCalling;
  const id = location.state?.id;

  useEffect(() => {
    if (id) {
      setSelectedContactId(id);
      setIsModalContactCustomer(true);
    }
  }, [id]);

  const inputSearchRef = useRef()

  const cleanFilter = (obj = {}) => {
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        result[key] = value;
      }
    });
    return result;
  };

  const onSearch = () => {
    setCurrentPage(1);
    setSearchTerm(inputSearchRef.current);
  }

  const buildFilterParams = (filter = {}) => {
    const params = {}
    const cleaned = cleanFilter(filter);
    Object.entries(cleaned).forEach(([key, value]) => {
      params[`filter[${key}]`] = value
    })
    return params
  }
  const getListContact = async () => {
    const baseFilter = cleanFilter({
      ...filter,
      expire_in_3_months: type === "renewBefore3Months" ? true : undefined,
    })
    const payload = {
      keyword: searchTerm || undefined,
      page: currentPage,
      per_page: perPage,
      // type: type !== "all" && type !== "renewBefore3Months" ? type : undefined,
      type: type !== "all" && type !== "renewBefore3Months" && type !== "newArchive" ? type : undefined,
      filter: Object.keys(baseFilter).length > 0 ? baseFilter : undefined,
    }
    dispatch(fetchContactList({ payload, type }))
    // try {
    //   setLoading(true);
    //   const response = await  HRService.getContactList(payload)
    //   //  (
    //   //   type === "archive"
    //   //     ? HRService.getDeleteContactList(payload)
    //   //     : HRService.getContactList(payload)
    //   // );
    //   const data = response?.success?.data.map(item => ({
    //                           code_contact: item.ID || "",
    //                           contact_name: item.full_name || "",
    //                           status: item.status,
    //                           phone: item.phone_number,
    //                           date_create: momentDateToString(item.created_at, DATE_FORMAT_SLASH),
    //                           updated_at: momentDateToString(item.updated_at, DATE_FORMAT_SLASH),
    //                           person_create: item?.personnel?.name || '',
    //                           expiry_date: momentDateToString(item.renewal_date, DATE_FORMAT_SLASH),
    //                           plate: item.license_plate,
    //                           vehicles_brand: item.brand,
    //                           vehicles_type: item.vehicle_type,
    //                           vehicles_chassis: item.chassis_number,
    //                           vehicles_engine: item.engine_number,
    //                           vehicles_tonnage: item.load_capacity,
    //                           vehicles_seat_capacity: item.number_of_seats,
    //                           intended_use: INTENDED_USE[item.usage_purpose]?.title || '',
    //                           city: item?.provinces?.title || '',
    //                           address: item.address,
    //                           assign: item?.assigned?.personnel?.name || '',
    //                           desc: item?.desc || '',
    //                           shipping_address: item?.shipping_address || '',
    //                           price: item?.price ? formatCurrency(parseFloat(item?.price)?.toString()) : '',
    //                       })) || [];
    //   setDataContact(data);
    //   setStatistical(response?.success?.statistical || {});
    //   setTotal(response?.success?.total || 0);
    // } catch (error) {
    //   console.error('Error fetching contact list:', error);
    // } finally {
    //   setLoading(false);
    // }
  }

  useEffect(() => {
    getListContact();
  }, [currentPage, perPage, status, type, searchTerm, filter]);
  const handDeleteContacts = (data) => {
    HRService.deleteContactList({ ids: data })
      .then(() => {
        Notice({
          isSuccess: true,
          msg: "Xóa liên hệ thành công",
        })
        getListContact()
      })
      .catch(err => {
        notice({
          isSuccess: false,
          msg: "Xóa liên hệ thất bại",
        })
      })
  }

  useEffect(() => {
    const cachedCars = sessionStorage.getItem('listCar');
    if (cachedCars) {
      setListCarState(JSON.parse(cachedCars));
    } else {
      CRMService.getCars()
        .then(res => {
          const cars = res.success || [];
          setListCarState(cars);
          sessionStorage.setItem('listCar', JSON.stringify(cars));
        })
        .catch(err => console.error('err', err));
    }
  }, []);
  const column = [
    {
      title: `Mã LH`,
      dataIndex: "code_contact",
      key: "code_contact",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 60 },
      }),
    },
    ...permissions.includes("contact.fullData") ? [{
      title: `Tên KH`,
      dataIndex: "contact_name",
      key: "contact_name",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 120 },
      }),
    }] : [],
    ...(type === 'return' ||type === 'renewal') ? [
      {
        title: `Giá tiền đã bán`,
        dataIndex: "price",
        key: "price",
        align: "center",
        onHeaderCell: () => ({
          style: { minWidth: 120 },
        }),
      },
      {
        title: `Địa chỉ nhận hàng`,
        dataIndex: "shipping_address",
        key: "shipping_address",
        align: "center",
        onHeaderCell: () => ({
          style: { minWidth: 150 },
        }),
      },
    ] : [],
    {
      title: "Thời hạn bảo hiểm",
      dataIndex: "expiry_date",
      key: "expiry_date",
      align: "center",
      sorter: (a, b) => {
        const dateA = new Date(a.expiry_date.split('/').reverse().join('-')); // Chuyển đổi thành "YYYY-MM-DD"
        const dateB = new Date(b.expiry_date.split('/').reverse().join('-')); // Chuyển đổi thành "YYYY-MM-DD"
        return dateA - dateB;
      },
      onHeaderCell: () => ({
        style: { minWidth: 90 },
      }),
    },
    {
      title: `Ngày ${type === 'archive' ? 'xóa' : 'gọi'}`,
      dataIndex: "updated_at",
      key: "updated_at",
      align: "center",
      onHeaderCell: headerCell,
    },
    ...permissions.includes("contact.fullData") ? [{
      title: "Biển kiểm soát",
      dataIndex: "plate",
      key: "plate",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 110 },
      }),
    }] : [],
    {
      title: "Nhãn hiệu",
      dataIndex: "vehicles_brand",
      key: "vehicles_brand",
      align: "center",
      onHeaderCell: headerCell,
    },
    {
      title: "Loại xe",
      dataIndex: "vehicles_type",
      key: "vehicles_type",
      align: "center",
      onHeaderCell: headerCell,
    },
    {
      title: (
        <>
          <MainTableHeader>Trọng tải</MainTableHeader>
          <SubTableHeader>Số chỗ</SubTableHeader>
        </>
      ),
      dataIndex: "vehicles_tonnage",
      key: "vehicles_tonnage",
      align: "center",
      render: (val, record) => (
        <>
          {record?.vehicles_tonnage && (
            <MainTableData>{`Trọng tải: ${record?.vehicles_tonnage}`}</MainTableData>
          )}
          {record?.vehicles_seat_capacity && (
            <SubTableData>{`Số chỗ: ${record?.vehicles_seat_capacity}`}</SubTableData>
          )}
        </>
      ),
      onHeaderCell: () => ({
        style: { minWidth: 110 },
      }),
    },
    {
      title: "Mục đích sử dụng",
      dataIndex: "intended_use",
      key: "intended_use",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 130 },
      }),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: val => {
        const objStatus = statusCall.filter(item => item.id === val)[0] || {}
        return <span>{objStatus.name}</span>
      },
      onHeaderCell: headerCell,
    },
    ...permissions.includes("contact.fullData") ? [{
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      align: "center",
      onHeaderCell: headerCell,
    }] : [],
    ...type === 'callback_Date' ? [
      {
        title: "Assign trước đó",
        dataIndex: "latest_assigned_history",
        key: "latest_assigned_history",
        align: "center",
        onHeaderCell: headerCell,
      },
    ] : [],
    {
      title: "Assign",
      dataIndex: "assign",
      key: "assign",
      align: "center",
      onHeaderCell: headerCell,
    },

    {
      title: "Ghi chú",
      dataIndex: "desc",
      key: "desc",
      align: "center",
      onHeaderCell: headerCell,
    },
    ...permissions.includes("contact.fullData") ? [{
      title: "Ngày tạo",
      dataIndex: "date_create",
      key: "date_create",
      align: "center",
      onHeaderCell: headerCell,
    }] : [],
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      onHeaderCell: () => ({
        style: { minWidth: 50 },
      }),
      onCell: () => ({
        onClick: event => event.stopPropagation(),
      }),
      render: (_, record) => {
        return (
          <PopupAction>
            {permissions.includes("contact.assigned") ? (
              <div onClick={() => setIsModalAssignerVisible(record.code_contact)}>
                <IconBase name="addUser" />
                <span>Assigner</span>
              </div>
            ) : <React.Fragment />}
            {permissions.includes("contact.restore") && type === "archive" ? (
              <div onClick={() => {
                CB1({
                  title: `Bạn có chắc chắn muốn khôi phục liên hệ này không?`,
                  icon: "refresh-blue",
                  okText: "Đồng ý",
                  onOk: async close => {
                    CRMService.restoreContact({ ids: [record.code_contact] })
                      .then(() => {
                        Notice({
                          isSuccess: true,
                          msg: "Khôi phục thành công",
                        })
                        getListContact()
                      })
                      .catch(err => {
                        notice({
                          isSuccess: false,
                          msg: "Khôi phục thất bại",
                        })
                      })
                  },
                })
              }}>
                <IconBase name="refresh" />
                <span>Khôi phục</span>
              </div>
            ) : <React.Fragment />}
            {
              status !== 'archive' ? (
                <div onClick={() => {
                  if (!permissions.includes("contact.delete")) {
                    Notice({
                      isSuccess: false,
                      msg: "Bạn không có quyền thực hiện hành động này!",
                    })
                    return
                  }
                  CB1({
                    title: `Bạn có chắc chắn xoá liên hệ này không?`,
                    icon: "trashRed",
                    okText: "Đồng ý",
                    onOk: async close => {
                      handDeleteContacts([record.code_contact])
                    },
                  })
                }}>
                  <IconBase name="delete" />
                  <span>Xóa</span>
                </div>
              ) : <React.Fragment />}
          </PopupAction>
        )
      },
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys)
    },
  };

  const itemsLeftRow1 = [
    {
      key: "create_person_charge",
      title: "Assigner",
      disable: selectedRowKeys.length === 0,
      onClick: () => {
        if (!permissions.includes("contact.assigned")) {
          Notice({
            isSuccess: false,
            msg: "Bạn chưa có quyền truy cập tính năng này!",
          })
          return
        }
        setIsModalAssignerVisible(true)
      },
    },
    ...(role === "ADMIN_ROLE" && type !== "newArchive") ? [{
      key: "fast_assigner",
      title: "Chia số nhanh",
      disable: false,
      component: (
        <Button
          btnType="primary"
          icon={<SvgIcon name="register" width={16} />}
          onClick={() => {
            if (role !== "ADMIN_ROLE" && permissions && !permissions.includes("contact.assigned")) {
              Notice({
                isSuccess: false,
                msg: "Bạn chưa có quyền truy cập tính năng này!",
              })
              return
            }
            setIsModalFastAssignerVisible(true)
          }}
        >
          Chia số nhanh
        </Button>
      )
    }] : [],
    ...type !== "newArchive" ? [
      {
        key: "delete_persons",
        title: "Delete All",
        disable: selectedRowKeys.length === 0,
        onClick: () => {
          setIsModalDeletes(true)
        },
      },
    ] : [],
    ...(permissions.includes("contact.restore") && type === "newArchive" ? [
      {
        key: "reload",
        title: "Khôi phục",
        disable: selectedRowKeys.length === 0,
        onClick: () => {
          CB1({
            title: `Bạn có chắc chắn muốn khôi phục các liên hệ đã chọn không?`,
            icon: "refresh-blue",
            okText: "Đồng ý",
            onOk: async close => {
              CRMService.restoreContact({ ids: selectedRowKeys })
                .then(() => {
                  Notice({
                    isSuccess: true,
                    msg: "Khôi phục thành công",
                  })
                  getListContact()
                })
                .catch(err => {
                  notice({
                    isSuccess: false,
                    msg: "Khôi phục thất bại",
                  })
                })
            },
          })
        },
      }
    ] : [])
    ,
    {
      key: "drop_down",
      component: (
        <SelectStyle
          onChange={(value) => updateTempFilter("province", value)}
          value={tempFilter.province || []}
          mode="multiple"
          showSearch
          placeholder="Chọn tỉnh thành"
          optionLabelProp="label"
          style={{ width: "170px", height: '37px' }}
          allowClear
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {listProvince.map(option => (
            <Select.Option key={option.title} value={option.plate_code} label={option.title}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>{option.title}</span>
                <Tag bordered={false} color="blue">
                  {option?.plate_code}
                </Tag>
              </div>
            </Select.Option>
          ))}

        </SelectStyle>
      ),
    },
    {
      key: "drop_down",
      component: (
        <SelectStyle
          onChange={(value) => updateTempFilter("status", value)}
          value={tempFilter.status}
          showSearch
          placeholder="Chọn trạng thái"
          optionLabelProp="label"
          style={{ width: "170px", height: '37px' }}
          allowClear
          options={statusCall.map(item => ({ value: item.id, label: item.name }))}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      )
    },
    ...((role === "ADMIN_ROLE" || (role === "SALES_DEPARTMENT_HEAD" && status !== 0)) ? [
      {
        key: "drop_down",
        component: (
          <SelectStyle
            placeholder="Phòng ban"
            allowClear
            disabled={type === 'not_assigned'}
            style={{ width: 170, height: 37 }}
            showSearch
            optionFilterProp="label"
            value={tempFilter?.department_id ?? undefined}
            onChange={(value) => {
              if (!value) {
                updateTempFilter("department_id", null)
                updateTempFilter("personnel_id", null)
              } else {
                updateTempFilter("department_id", Number(value))
              }

              dispatch(setDepartmentId(value || null))
            }}
            options={listDepartment.map(d => ({ value: d.ID, label: d.title }))}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        ),
      },
      {
        key: "drop_down",
        component: (
          <SelectStyle
            placeholder="Assigner"
            allowClear
            value={tempFilter.personnel_id}
            style={{ width: "170px", height: '37px' }}
            showSearch
            optionFilterProp="label"
            onChange={(value) => {
              updateTempFilter("personnel_id", value)
            }}
            options={listPersonnelAssigner.map(item => ({ value: item.ID, label: item.name }))}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        ),
      },
    ] : [{}]),
  ];

  const itemsLeftRow2 = [
    ...type === 'callback_Date' ? [
      {
        key: "date_picker",
        component: (
          <DatePicker
            allowClear={true}
            defaultValue={dayjs()}
            value={
              tempFilter.callback_Date
                ? dayjs(tempFilter.callback_Date)
                : null
            }
            format="DD/MM/YYYY"
            style={{ width: '230px' }}
            placeholder={"Ngày gọi lại"}
            onChange={(date) => {
              setTempFilter(prevState => ({
                ...prevState,
                callback_Date: date ? dayjs(date).format('YYYY-MM-DD') : null
              }))
            }}
          />
        ),
      },
    ] : [
      // {
      //   key: "drop_down",
      //   component: (
      //     <SelectStyle
      //       onChange={(value ) => {
      //         if (value === undefined || value === "") {
      //           const newFilter = { ...filter };
      //           delete newFilter.status;
      //           setFilter(newFilter);
      //           return
      //         }
      //         setFilter((prevState) => ({...prevState, status: value}))
      //       }}
      //       showSearch
      //       placeholder="Chọn trạng thái"
      //       optionLabelProp="label"
      //       style={{ maxWidth: '200px', width: '150px', height: '37px' }}
      //       allowClear
      //       options={statusCall.map(item => ({ value: item.id, label: item.name }))}
      //       filterOption={(input, option) =>
      //         option.label.toLowerCase().includes(input.toLowerCase())
      //       }
      //     />
      //   )
      // },
      {
        key: "drop_down",
        component: (
          <Select
            placeholder={'Chọn loại xe'}
            value={tempFilter.vehicle_type}
            allowClear
            showSearch
            optionFilterProp="label"
            style={{ width: "170px", height: '37px' }}
            onChange={(value) => {
              updateTempFilter("vehicle_type", value);
            }}
            options={listCarState.map(item => ({ value: item.title, label: item.title }))}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        ),
      },
      {
        key: "date_picker",
        component: (
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            style={{ width: '230px' }}
            value={
              tempFilter.start_date && tempFilter.end_date
                ? [dayjs(tempFilter.start_date), dayjs(tempFilter.end_date)]
                : null
            }
            placeholder={['Bắt đầu BH', 'Kết thúc BH']}
            onChange={(dates) => {
              if (!dates) {
                updateTempFilter("start_date", null);
                updateTempFilter("end_date", null);
                return;
              }

              updateTempFilter(
                "start_date",
                dayjs(dates[0]).format("YYYY-MM-DD")
              );

              updateTempFilter(
                "end_date",
                dayjs(dates[1]).format("YYYY-MM-DD")
              );
            }}
          />
        ),
      },
      {
        key: "date_picker",
        component: (
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            style={{ width: '230px' }}
            value={
              tempFilter.start_updated && tempFilter.end_updated
                ? [dayjs(tempFilter.start_updated), dayjs(tempFilter.end_updated)]
                : null
            }
            placeholder={['Ngày gọi', 'Ngày gọi']}
            onChange={(dates) => {
              if (!dates) {
                updateTempFilter("start_updated", null);
                updateTempFilter("end_updated", null);
                return;
              }

              updateTempFilter(
                "start_updated",
                dayjs(dates[0]).format("YYYY-MM-DD")
              );

              updateTempFilter(
                "end_updated",
                dayjs(dates[1]).format("YYYY-MM-DD")
              );
            }}
          />
        ),
      },
      ...(type === "renewal" ? [{
        key: "date_picker",
        component: (
          <DatePicker
            format="DD/MM/YYYY"
            placeholder={['Ngày hẹn gọi lại']}
            onChange={(date) => {
              updateTempFilter(
                "callback_Date",
                date ? dayjs(date).format("YYYY-MM-DD") : null
              );
            }}
          />
        )
      }] : []),
      {
        key: "drop_down",
        component: (
          <Select
            allowClear={true}
            placeholder="Chọn trạng thái gán"
            value={tempFilter.assigned}
            showSearch
            optionFilterProp="label"
            style={{ width: "170px", height: "37px" }}
            onChange={(value) => {
              updateTempFilter("assigned", value);
            }}
            options={[
              { value: true, label: "Đã được gán" },
              { value: false, label: "Chưa được gán" },
            ]}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        ),
      },
    ],
    {
      key: "filter",
      title: "Lọc",
      component: (
        <Button
          btnType="primary"
          icon={<SvgIcon name="filter-white1" width={16} />}
          style={{ height: 36, borderRadius: 6 }}
          // onClick={() => setFilter({...filter, ...tempFilter})}
          // onClick={() => setFilter(tempFilter)}
          onClick={() => {
            const merged = { ...filter, ...tempFilter };
            const newFilter = cleanFilter(merged);

            setCurrentPage(1);

            setTempFilter(newFilter);
            setFilter(newFilter);
          }}
        >
          Lọc
        </Button>
      )
    }
  ];

  const itemsRight = [
    {
      key: "input_search",
      component: (
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Biển KS, Địa chỉ, Loại xe ..."
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" onClick={onSearch} />
          </div>
        </InputSearchStyle>
      ),
    },
    ...(permissions.includes('contact.import') && status === 0 ? [
      {
        key: "import_excel",
        title: "Tải file lên",
        disable: false,
        onClick: () => { setIsModalAssignerImport(true) },
      }
    ] : []),
  ];
  const itemsRight2 = [
    {
      key: "reset",
      title: "Reset",
      component: (
        <Button
          icon={<SvgIcon name="clear-orange" width={16} />}
          style={{ height: 36, borderRadius: 6 }}
          onClick={() => {
            const defaultFilter =
              type === "callback_Date"
                ? { callback_Date: dayjs().format('YYYY-MM-DD') }
                : type === "renewal" || type === "return"
                  ? { assigned: false }
                  : {};
            setTempFilter(defaultFilter);
            setFilter(defaultFilter);
            setCurrentPage(1);
            dispatch(setDepartmentId(null));
          }}
        >
          Xóa bộ lọc
        </Button>
      )
    },
  ]
  const handleCloseModal = () => {
    setIsModalAssignerVisible(false);
  };

  const handleCloseModalImport = () => {
    setIsModalAssignerImport(false);
  };
  const handleImportSuccess = () => {
    handleCloseModal();
    getListContact()
  };

  return (
    <WrapperStyle>
      <ToolBarCustomLayer itemsLeft={itemsLeftRow1} itemsRight={itemsRight} />
      <ToolBarCustomLayer itemsLeft={itemsLeftRow2}
        itemsRight={itemsRight2} wrapType="wrap"
      />
      <div style={{ display: 'flex', flexDirection: 'row', margin: '10px 0' }}>
        <div style={{ padding: '0 5px', color: '#007BFF' }}><strong>Tổng liên hệ:</strong> {total}</div>
        <div style={{ padding: '0 5px', color: '#28A745' }}><strong>Trạng thái mới:</strong> {statistical?.status_new || 0}</div>
        <div style={{ padding: '0 5px', color: '#DC3545' }}><strong>Trạng thái còn lại:</strong> {statistical?.status_call || 0}</div>
      </div>
      <TableCustom
        noMrb
        isPrimary
        columns={column}
        onRow={(record) => ({
          onClick: (event) => {
            if (
              !event.target.closest(".ant-checkbox-wrapper") && // Không phải checkbox
              !event.target.closest("td.ant-table-selection-column") // Không phải cột select
            ) {
              if (!permissions.includes("contact.detail")) {
                Notice({
                  isSuccess: false,
                  msg: "Bạn chưa có quyền truy cập tính năng này!",
                })
                return;
              }
              setSelectedContactId(record?.code_contact);
              setIsModalContactCustomer(true);
            }
          }
        })}
        dataSource={dataContact}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: perPage,
          total: total,
        }}
        rowKey={record => record.code_contact}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
      />
      <PaginationStyle
        pageSizeOptions={PAGE_SIZE}
        current={currentPage}
        pageSize={perPage}
        defaultPageSize={50}
        showSizeChanger
        onShowSizeChange={(page, pageSize) => {
          setPerPage(pageSize);
          setCurrentPage(page);
        }}
        onChange={(page, pageSize) => {
          setCurrentPage(page);
          setPerPage(pageSize);
        }}
        defaultCurrent={1}
        total={total}
        itemRender={(page, type, originalElement) => {
          if (type === 'page') {
            return (
              <span
                style={{
                  fontWeight: page === currentPage ? 'bold' : 'normal',
                  color: page === currentPage ? '#1890ff' : 'inherit', // Hiển thị màu khi trang hiện tại đang active
                }}
              >
                {page}
              </span>
            );
          }
          return originalElement;
        }}
      />
      {isModalAssignerVisible && (
        <CustomModal
          title={"Assigner"}
          footer={null}
          size={'small'}
          open={isModalAssignerVisible}
          onCancel={handleCloseModal}
        >
          <ModalAssigner
            status={status}
            dataSelected={selectedRowKeys}
            getData={getListContact}
            open={[isModalAssignerVisible]}
            onCancel={handleCloseModal}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </CustomModal>
      )}
      {isModalFastAssignerVisible && (
        <ModalFastAssigner
          open={isModalFastAssignerVisible}
          onCancel={() => setIsModalFastAssignerVisible(false)}
          onSuccess={() => {
            setIsModalFastAssignerVisible(false);
            getListContact();
          }}
          filter={filter}
          type={type}
          searchTerm={searchTerm}
          total={total}
        />
      )}
      {isModalDeletes && (
        <CustomModal
          title={"Xác nhận xoá"}
          footer={null}
          size={'small'}
          open={isModalDeletes}
          onCancel={() => setIsModalDeletes(false)}
        >
          <ModalConfirmDelete
            onCancel={() => setIsModalDeletes(false)}
            onDelete={() => {
              handDeleteContacts(selectedRowKeys);
              setIsModalDeletes(false)
            }}
            selectedRowKeys={selectedRowKeys}
          />
        </CustomModal>
      )}
      {isModalAssignerImport && (
        <CustomModal
          title={"Tải file lên"}
          footer={null}
          size={'small'}
          open={isModalAssignerImport}
          onCancel={handleCloseModalImport}
        >
          <ImportModal
            open={isModalAssignerImport}
            onCancel={handleCloseModalImport}
            onOk={handleImportSuccess}
          />
        </CustomModal>
      )}
      {isModalContactCustomer && (
        <CustomModal
          title={'Liên hệ khách hàng'}
          open={isModalContactCustomer}
          onCancel={() => {
            callState === CALL_STATE.UNAVAILABLE && setIsModalContactCustomer(false)
            setSearchParams({})
          }}
          footer={null}
          size='large'
        >
          <ContactCustomer
            isCalling={isCalling}
            contactId={selectedContactId}
            setIsModal={setIsModalContactCustomer}
            onCancel={() => {
              setIsModalContactCustomer(false)
              setSearchParams({})
            }}
            type={type}
          />
        </CustomModal>
      )}
    </WrapperStyle>
  )
}

export default Index
